import GlobalBankPanel from './GlobalBankPanel';
import PerUserBankPanel from './PerUserBankPanel';
import PerCountryBankPanel from './PerCountryBankPanel';
import CryptoWalletsPanel from './CryptoWalletsPanel';
import PaymentLinksPanel from './PaymentLinksPanel';
import { KycConfigPanel } from './KycPluginConfig';
import CreditSystemPanel from './CreditSystemPanel';
import EmailTemplatesPanel from './EmailTemplatesPanel.jsx';
import PagesPlugin from './PagesPlugin';
import RiskGuardConfig from './RiskGuardConfig';
import PositionMonitorConfig from './PositionMonitorConfig';

import LiveChatPanel from './LiveChatPanel';
import PlatformNotificationsPanel from './PlatformNotificationsPanel';


export const PLUGIN_REGISTRY = {
  bank_transfer_global: {
    component: GlobalBankPanel,
    dataKey: 'bankAccounts',
    filterData: (data) => data.filter(a => a.plugin_type === 'global'),
    fullPage: false, // ← Stays in drawer
  },
  bank_transfer_per_user: {
    component: PerUserBankPanel,
    dataKey: 'bankAccounts',
    filterData: (data) => data.filter(a => a.plugin_type === 'per_user'),
    fullPage: false, // ← Stays in drawer
  },
  bank_transfer_per_country: {
    component: PerCountryBankPanel,
    dataKey: 'bankAccounts',
    filterData: (data) => data.filter(a => a.plugin_type === 'per_country'),
    fullPage: false, // ← Stays in drawer
  },
  crypto_payments: {
    component: CryptoWalletsPanel,
    dataKey: 'cryptoWallets',
    fullPage: false, // ← Stays in drawer
  },
  payment_links: {
    component: PaymentLinksPanel,
    dataKey: 'paymentLinks',
    fullPage: false, // ← Stays in drawer
  },
  kyc_verification: {
    component: KycConfigPanel,
    dataKey: 'kycConfig',
    requiresStats: true,
    fullPage: true, // ✅ Opens full page
  },
  credits: {
    component: CreditSystemPanel,
    dataKey: 'credits',
    fullPage: true, // ✅ Opens full page
  },
  email_templates: {
    component: EmailTemplatesPanel,
    dataKey: null,
    fullPage: true, // ✅ Opens full page
  },
  pages: {
    component: PagesPlugin,
    dataKey: null,
    fullPage: true,
  },
  risk_guard: {
    component: RiskGuardConfig,
    dataKey: null,
    fullPage: true,   // Opens in drawer (config is compact enough)
  },
  position_monitor: {
    component: PositionMonitorConfig,
    dataKey: null,
    fullPage: true,   // Opens in drawer
  },
  live_chat: {
    component: LiveChatPanel,
    dataKey: null,
    fullPage: false,  // compact config — stays in drawer
  },
  platform_notifications: {
    component: PlatformNotificationsPanel,
    dataKey: null,
    fullPage: true,   // opens full page — notification list is long
  },

};

export function getPluginConfig(pluginKey) {
  return PLUGIN_REGISTRY[pluginKey] || null;
}

export function isPluginRegistered(pluginKey) {
  return pluginKey in PLUGIN_REGISTRY;
}

export function getRegisteredPluginKeys() {
  return Object.keys(PLUGIN_REGISTRY);
}